// extracted by mini-css-extract-plugin
export var jointSolutionDetailCard = "index-module--jointSolutionDetailCard--1i89l";